const stories = [
    {
        image: 'insights/stories/wise-snacks-consumer-insights-case-study.png',
        description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Wise Snacks achieved <span style="color: #0E47C0;">4x faster</span> product development via iterative IHUT and sensory testing.</span>',
        uri: '/',
        alt: 'Wise Snacks consumer insights case study',
    },
    {
        image: 'insights/stories/tribe9foods-consumer-insights-case-study.png',
        description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Tribe9Foods cut packaging costs <span style="color: #009B8E;">by 3x</span> through A/B testing and adopting a more economical option.</span>',
        uri: '/',
        alt: 'Tribe9Foods consumer insights case study',
    },
    {
        image: 'insights/stories/bellwether-customer-insights-case-study.png',
        description: '<span class="font-manrope font-extrabold text-[22px] leading-8" style="color: #141414;">Bellweather validated existing <span style="color: #F78834;">Buyer Persona</span> and discovered new expansion segments.</span>',
        uri: '/',
        alt: 'Bellwether customer insights case study',
    },
];

export default stories;
